import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function Login({ onSwitchToRegister, onForgotPassword }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (!result.success) {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4 pt-16">
      {/* Background gradient effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-[#DF1283]/20 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-[#4A0A66]/30 rounded-full blur-[120px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#0FFFE2]/5 rounded-full blur-[150px]" />
      </div>

      <div className="relative w-full max-w-md">
        {/* Logo/Brand */}
        <div className="text-center mb-8">
          <img 
            src="/calculator-logo.png" 
            alt="UnCloned® Offer Calculator"
            className="h-24 mx-auto"
          />
        </div>

        {/* Login Card */}
        <div className="relative">
          {/* Glow border effect */}
          <div className="absolute -inset-0.5 bg-gradient-to-r from-[#DF1283] via-[#4A0A66] to-[#0FFFE2] rounded-2xl opacity-50 blur-sm" />
          
          <div className="relative bg-black/90 backdrop-blur-xl rounded-2xl p-8 border border-[#4A0A66]/30">
            <h2 className="text-2xl font-bold text-white mb-6 text-center">Welcome Back</h2>
            
            <form onSubmit={handleSubmit} className="space-y-5">
              {error && (
                <div className="bg-[#DF1283]/10 border border-[#DF1283]/50 rounded-lg px-4 py-3 text-[#DF1283] text-sm">
                  {error}
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="login-email-input"
                  className="w-full px-4 py-3 bg-[#0a0014] border border-[#4A0A66]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0FFFE2] focus:ring-1 focus:ring-[#0FFFE2]/50 transition-all"
                  placeholder="you@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="login-password-input"
                  className="w-full px-4 py-3 bg-[#0a0014] border border-[#4A0A66]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0FFFE2] focus:ring-1 focus:ring-[#0FFFE2]/50 transition-all"
                  placeholder="••••••••"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                data-testid="login-submit-button"
                className="w-full py-3 px-4 bg-gradient-to-r from-[#DF1283] to-[#FF7901] text-white font-semibold rounded-lg hover:opacity-90 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-[#DF1283]/25"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Signing In...
                  </span>
                ) : (
                  'Sign In'
                )}
              </button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-gray-400 text-sm">
                Don't have an account?{' '}
                <button
                  onClick={onSwitchToRegister}
                  data-testid="switch-to-register"
                  className="text-[#0FFFE2] hover:text-[#D0FF0B] font-medium transition-colors"
                >
                  Create one
                </button>
              </p>
              <button
                onClick={onForgotPassword}
                data-testid="forgot-password-link"
                className="text-gray-500 hover:text-[#FF7901] text-sm mt-3 transition-colors"
              >
                Need help logging in?
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-xs text-white/40 mt-8">
          <p>© 2025-2026 UnCloned® Media. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
}
